import styled from 'styled-components'

import { Row } from 'Components/UI'

export const Container = styled(Row)``
